
<footer class="mt-5 footer-internal position-relative" *ngIf="isLoggedIn == true">

  <p>Copyright 2024 | All Rights Reserved.</p>
</footer>
